








import { defineComponent, ref } from "@vue/composition-api";
import { PersonalInformation } from "@scrile/api-provider/dist/api/PersonalInformationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import { personalInfoFields } from "../config";

export default defineComponent({
  name: "PersonalInfoForm",
  components: { BaseForm },
  setup(_, { emit }) {
    const { authUser } = useAuthUser();
    const personalInformation = ref<PersonalInformation | null>(null);
    const values = ref<FormValues>({
      firstName: "",
      lastName: "",
      phone: "",
      dateOfBirth: "",
      roomType: "",
    });

    const onValidation = (valid: boolean) => {
      emit("setValid", valid);
    };

    const getData = async () => {
      if (!authUser.value) return;
      personalInformation.value = await providers.PersonalInformationProvider.find({ id: authUser.value.id });
      values.value = {
        firstName: personalInformation.value.firstName,
        lastName: personalInformation.value.lastName,
        phone: personalInformation.value.phone,
        dateOfBirth: personalInformation.value.dateOfBirth,
        roomType: personalInformation.value.roomType,
      };
    };

    const submitPersonalInfo = async () => {
      if (!authUser.value) return;
      const data = {
        userId: authUser.value.id,
        firstName: values.value.firstName,
        lastName: values.value.lastName,
        phone: values.value.phone,
        dateOfBirth: new Date(values.value.dateOfBirth).toISOString(),
        roomType: values.value.roomType,
      };
      personalInformation.value = await providers.PersonalInformationProvider.update({ data });
      values.value = {
        ...values.value,
        firstName: personalInformation.value.firstName,
        lastName: personalInformation.value.lastName,
        phone: personalInformation.value.phone,
        dateOfBirth: personalInformation.value.dateOfBirth,
        roomType: personalInformation.value.roomType,
      };
    };

    const created = async () => {
      emit("setValid", true);
      emit("setCb", () => submitPersonalInfo());
      try {
        emit("setLoading", true);
        await getData();
      } finally {
        emit("setLoading", false);
      }
    };

    created();

    return {
      values,
      onValidation,
      personalInfoFields,
    };
  },
});
